<template>
    <div>
        <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>


    </div>
</template>
  
<script>
// isApplet 1是小程序跳转的
import vuePdf from "vue-pdf";
const pdf = { ...vuePdf, destroyed: undefined }

export default {
    components: {
        pdf
    },
    props: {
        fileUrl: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            pdfUrl: "",
            numPages: undefined,
        }
    },
    watch: {
        fileUrl: {
            deep: true,
            handler(val) {
                this.numPages = undefined;
                this.openPage()
            }
        }
    },

    mounted() {
        this.numPages = undefined;
    },
    methods: {
        openPage() {
            let pdfUrl = this.fileUrl;
            var loadingTask = pdf.createLoadingTask(pdfUrl);

            this.pdfUrl = loadingTask;
            this.pdfUrl.promise.then(pdf => {
                this.numPages = pdf.numPages;
                console.log(this.numPages, pdf.numPages)
            }).catch(err => {
                console.log('err', err)
            });

        }
    }
}
</script>
  
<style lang="scss" scoped></style>